import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ text, link, cote = 'center' }) => {
    return (
        <div className={`button ${cote}`}>
            <Link to={link} className='btn'>
                {text}
            </Link>
        </div>
    );
};

export default Button;
